import { render, staticRenderFns } from "./helpText.vue?vue&type=template&id=2767bc18&scoped=true&"
import script from "./helpText.vue?vue&type=script&lang=js&"
export * from "./helpText.vue?vue&type=script&lang=js&"
import style0 from "./helpText.vue?vue&type=style&index=0&id=2767bc18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767bc18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
